import { render, staticRenderFns } from "./MultiplicationAndDivisionMathMagicForm.vue?vue&type=template&id=686e237a&scoped=true&lang=pug&"
import script from "./MultiplicationAndDivisionMathMagicForm.vue?vue&type=script&lang=js&"
export * from "./MultiplicationAndDivisionMathMagicForm.vue?vue&type=script&lang=js&"
import style0 from "./MultiplicationAndDivisionMathMagicForm.vue?vue&type=style&index=0&id=686e237a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "686e237a",
  null
  
)

export default component.exports